module.exports = __webpack_public_path__ + "img/img_inner_browntartan.3cdfa3cb.png";